import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, signInImage } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import FileUploadImage from "./ImageGroup";
import StudentExamModal from "./StudentExamModal";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import converter from 'number-to-words'
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [ReceiptNumber, setReceiptNumber] = React.useState(FetchData.meta.receipt_number)
  const [StudentFetch, setStudentFetch] = React.useState(false)
  const [StudentID, setStudentID] = React.useState(FetchData.meta.student_id)
  const [StudentRoll, setStudentRoll] = React.useState("")
  const [StudentName, setStudentName] = React.useState(FetchData.meta.student_name)
  const [StudentSlug, setStudentSlug] = React.useState(FetchData.meta.student_slug)
  const [PaymentDate, setPaymentDate] = React.useState(FetchData.meta.payment_date)
  const [Amount, setAmount] = React.useState(FetchData.meta.amount)
  const [PaymentType, setPaymentType] = React.useState(FetchData.meta.payment_type)
  const [PaymentMode, setPaymentMode] = React.useState(FetchData.meta.payment_mode)
  const [ReferenceNumber, setReferenceNumber] = React.useState(FetchData.meta.reference_number)
  const [ReceivedBy, setReceivedBy] = React.useState(FetchData.meta.received_by)
  const [Remarks1, setRemarks1] = React.useState(FetchData.meta.remarks1)
  const [Remarks2, setRemarks2] = React.useState(FetchData.meta.remarks2)
  const [Remarks3, setRemarks3] = React.useState(FetchData.meta.remarks3)
  const [ReceivedFrom, setReceivedFrom] = React.useState(FetchData.meta.received_from)
  const [Screenshot, setScreenshot] = React.useState(FetchData.meta.screenshot == "" ? [] : JSON.parse(FetchData.meta.screenshot))
  const [Items, setItems] = React.useState(FetchData.meta.items == "" ? [] : JSON.parse(FetchData.meta.items))
  const [ShowScreenShotGroupList, setShowScreenShotGroupList] = React.useState(true)
  const [ShowItemsGroupList, setShowItemsGroupList] = React.useState(true)

  const [StudentsList, setStudentsList] = React.useState([])
  const [StudentsList1, setStudentsList1] = React.useState([])
  const [StudentModal, setStudentModal] = React.useState(false)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const EditInfo = () => {
    setReload(true)
    var receipt_number = ReceiptNumber
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "receipt_number": `${ReceiptNumber}`,
        "payment_type": `${PaymentType}`,
        "student_id": `${StudentID}`,
        "student_name": `${StudentName}`,
        "student_slug": `${StudentSlug}`,
        "payment_date": `${PaymentDate}`,
        "amount": `${Amount}`,
        "payment_mode": `${PaymentMode}`,
        "items": JSON.stringify(Items),
        "reference_number": `${ReferenceNumber}`,
        "received_by": `${ReceivedBy}`,
        "remarks1": `${Remarks1}`,
        "remarks2": `${Remarks2}`,
        "remarks3": `${Remarks3}`,
        "screenshot": JSON.stringify(Screenshot),
        "received_from": `${ReceivedFrom}`
      }
    }
    if (ID === "") {
      AdsGETApiAuth({ per_page: 1 }, slugs.db_slug_payments_received)
        .then(res => {
          receipt_number = Number(res.headers["x-wp-total"]) + 1
          AdsPOSTApi({
            ...data,
            meta: {
              ...data.meta,
              "receipt_number": `${receipt_number}`,
            }
          }, slugs.db_slug_payments_received)
            .then((res) => {
              setReload(false)
              setID(res.data.id)
              setAlertShow(true)
              setAlertcomp("Added Successfully")
              history.push(`${slugs.payments_received_details}${res.data.slug}`)
            }).catch(err => {
              setReload(false)
              console.log(err)
              setAlertShow(true)
              setAlertcomp(err.response.data.message)
            })
        })

    }
    else
      AdsPUTApi(data, slugs.db_slug_payments_received, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`Successfully Edited`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  const location = useLocation()
  const invoiceComponentRef = React.useRef(null);
  const invoiceComponentPrint = useReactToPrint({
    content: () => invoiceComponentRef.current,

  })

  // const [searchParams] =

  useEffect(() => {
    GetAllStudents()
  }, [])

  const GetAllStudents = (params) => {
    setStudentsList([])
    AdsGETApiAuth(
      {
        per_page: 10000,
        _fields: "id,title,slug,meta"
      }, slugs.db_slug_students)
      .then((res) => {
        setStudentsList(res.data)
        setStudentsList1(res.data)
        console.log(location.search.search("student_name"))
        if (location.search.search("student_id") !== -1 || StudentID !== "") {
          var value_search, index
          if (location.search.search("student_id") !== -1) {
            value_search = location.search.search("student_id") + 11
            index = location.search.slice(value_search)
          }
          else {
            value_search = StudentID
            index = StudentID
          }
          console.log("aaa", index)
          var search_student = res.data.filter(a => a.id == index)
          if (search_student.length == 1) {
            const date = new Date()
            setTitle(`${search_student[0].meta.name} Payment ${date.toDateString()}`)
            setStudentID(search_student[0].id)
            setStudentName(search_student[0].meta.name)
            setStudentSlug(search_student[0].slug)
            setStudentRoll(search_student[0].meta.roll_no)
            setPaymentType("Student")
            setStudentFetch(true)
            var newValue = {
              "name": "",
              "qty": 0,
              "rate": 0,
              "total": 0
            }
            var courseList = JSON.parse(search_student[0].meta.course_details)
            var courseListArray = Object.values(courseList)
            var ItemList = {}
            for (let i = 0; i < courseListArray.length; i++) {
              ItemList = {
                ...ItemList,
                [i]: {
                  "name": courseListArray[i].course_name,
                  "qty": 1,
                  "rate": courseListArray[i].course_joined_price,
                  "total": courseListArray[i].course_joined_price
                }
              }
            }
            console.log(ItemList)
            setItems(ItemList)
          }
        }

      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }

  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Batch Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Title</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Receipt Number</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={ReceiptNumber} placeholder="Receipt Number"
                    onChange={(event) => { setReceiptNumber(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Payment Type</td>
                <td className="col-6">
                  {ID == "" ?
                    <>
                      <CustomButton Data={PaymentType} setData={setPaymentType} DataValue={"Student"} />
                      <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}
                        onClick={() => {
                          setPaymentType("Other")
                          setStudentID("")
                          setStudentName("")
                          setStudentSlug("")
                        }}
                      >
                        <div className={PaymentType == "Other" ? "active-option" : "passive-option"}>
                          Other
                        </div>
                      </button>
                    </>
                    :
                    <>
                      <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}>
                        <div className={"active-option"}>
                          {PaymentType}
                        </div>
                      </button>
                    </>
                  }
                </td>

              </tr>
              {PaymentType == "Student" &&
                <>
                  <tr>
                    <td className="col-3">Student Roll No</td>
                    <td className="col-6" >
                      <div className="input-common"
                        onClick={() => {
                          if (ID == "")
                            if (!StudentFetch)
                              setStudentModal(true)
                        }}>
                        {StudentRoll}&nbsp;
                      </div>
                      {/* <input className="input-common" disabled
                    value={StudentID} placeholder="StudentID"
                    onChange={(event) => { setStudentID(event.target.value) }}
                  /> */}
                    </td>
                  </tr>
                  <tr>
                    <td className="col-3">Student Name</td>
                    <td className="col-6">
                      <div className="input-common"
                        onClick={() => {
                          if (ID == "")
                            if (!StudentFetch)
                              setStudentModal(true)
                        }}>
                        {StudentName}&nbsp;
                      </div>
                      {/* <input className="input-common" disabled
                    value={StudentName} placeholder="Student Name"
                    onChange={(event) => { setStudentName(event.target.value) }}
                  /> */}
                      {StudentSlug !== "" &&
                        <a className="Link" href={`${slugs.students_details}${StudentSlug}`}>
                          View
                        </a>
                      }
                    </td>
                  </tr>
                </>}
              <tr>
                <td className="col-3">Payment Date</td>
                {/* <td className="col-6">
                  <input className="input-common" disabled
                    value={FetchData.date.slice(0, 10)} placeholder="Payment Date"
                    onChange={(event) => { setPaymentDate(event.target.value) }}
                  />
                </td> */}
                <td className="nepali-date-cell">
                  {/* <div className="topic-popup"> */}
                  <div className="attendance-date-picker">
                    <div className="small-nepali-datepicker"
                    >
                      {/* {item.date} */}
                      <NepaliDatePicker style={{ cursor: "pointer" }}
                        inputClassName="input-common" placeholder={"date"}
                        value={PaymentDate || ""}
                        onChange={(selectedDate) => {
                          setPaymentDate(selectedDate)
                        }
                        }
                        options={{
                          calenderLocale: "ne",
                          valueLocale: "en",
                        }}
                        placeholder="मिति छान्नुहोस्"
                      // onSelect={() => { setOpencalendar(true) }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              {/* {JSON.stringify(Object.values(Items))} */}
              <tr>
                <td className="col-3">Items</td>
                <td className="col-9">
                  {/* {ID !== "" ? */}
                    <>
                      {ShowItemsGroupList &&
                        <div style={{ padding: "0 10px" }}>
                          {Object.values(Items).map((item, index) => (
                            <div key={index} style={{ display: "flex", padding: "3px 0" }}>
                              <span style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</span>
                                
                              <span>
                                <div>
                                  <input className="input-common-items"
                                    value={item.name} placeholder="Items"
                                    onChange={(event) => {
                                      setItems({
                                        ...Items,
                                        [Object.keys(Items)[index]]: {
                                          ...Object.values(Items)[index],
                                          "name": event.target.value
                                        }
                                      })
                                    }}
                                  />
                                  <input className="input-common-items"
                                    value={item.qty} placeholder="QTY" type="number"
                                    onChange={(event) => {
                                      var total = Number(event.target.value) * item.rate
                                      var grantTotal = 0;
                                      var allItems = {
                                        ...Items,
                                        [Object.keys(Items)[index]]: {
                                          ...Object.values(Items)[index],
                                          "qty": event.target.value,
                                          "total": total
                                        }
                                      }
                                      var allItemsARray = Object.values(allItems)
                                      for (let i = 0; i < allItemsARray.length; i++) {
                                        console.log()
                                        grantTotal += Number(allItemsARray[i].total)
                                      }
                                      setAmount(grantTotal)
                                      setItems(allItems)
                                    }}
                                  />
                                  <input className="input-common-items"
                                    value={item.rate} placeholder="Rate" type="number"
                                    onChange={(event) => {
                                      // var total = Number(event.target.value) * item.qty
                                      // setItems({
                                      //   ...Items,
                                      //   [Object.keys(Items)[index]]: {
                                      //     ...Object.values(Items)[index],
                                      //     "rate": event.target.value,
                                      //     "total": total
                                      //   }
                                      // })
                                      var total = Number(event.target.value) * item.qty
                                      var grantTotal = 0;
                                      var allItems = {
                                        ...Items,
                                        [Object.keys(Items)[index]]: {
                                          ...Object.values(Items)[index],
                                          "rate": event.target.value,
                                          "total": total
                                        }
                                      }
                                      var allItemsARray = Object.values(allItems)
                                      for (let i = 0; i < allItemsARray.length; i++) {
                                        console.log()
                                        grantTotal += Number(allItemsARray[i].total)
                                      }
                                      setAmount(Math.round(grantTotal, 2))
                                      // setVAT(Math.round(grantTotal * 0.13, 2))
                                      // setTotalAfterVAT(Math.round(grantTotal - grantTotal * 0.13, 2))
                                      setItems(allItems)
                                    }}
                                  />
                                  <input className="input-common-items" disabled
                                    value={item.total} placeholder="Total"
                                  />
                                </div>
                              </span>
                              <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                                var ObjectForDelete = Items
                                var key = Object.keys(Items)[index]
                                // console.log(key, Items)
                                delete ObjectForDelete[key];
                                setItems(ObjectForDelete)
                                setShowItemsGroupList(false)
                                setTimeout(() => {
                                  setShowItemsGroupList(true)
                                }, 10)
                              }}>
                                Del
                              </span>
                            </div>
                          ))}
                          <div className=" col-3" style={{ padding: "0 10px" }}>
                            <div className="sign-in-button-small"
                              onClick={() => {
                                var newValue = {
                                  "name": "",
                                  "qty": 0,
                                  "rate": 0,
                                  "total": 0
                                }
                                var lastkey = Object.keys(Items).length == 0 ? -1 : Number(Object.keys(Items)[Object.keys(Items).length - 1])
                                // console.log(lastkey + 1)
                                var newKey = `${lastkey + 1}`
                                var newObject = Items;
                                newObject = {
                                  ...Items,
                                  [newKey]: newValue
                                }
                                // console.log(newObject)

                                setItems(newObject)
                              }}
                            >
                              Add Item
                            </div>
                          </div>
                        </div>
                      }
                    </>
                    {/* :
                    <>
                      {Object.values(Items).map((item, index) => (
                        <div key={index} style={{ display: "flex", padding: "3px 0" }}>
                          <span style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</span>
                          <span>
                            <div>
                            </div>
                          </span>
                        </div>
                      ))}
                    </>

                  } */}
                </td>
              </tr>
              <tr>
                <td className="col-3">Payment Amount</td>
                <td className="col-6">
                  <input className="input-common" disabled={ID !== ""}
                    value={Amount} placeholder="Payment Amount"
                    onChange={(event) => { setAmount(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Payment Mode</td>
                <td className="col-6">
                  {/* {ID == "" ? */}
                    <>
                      <CustomButton Data={PaymentMode} setData={setPaymentMode} DataValue={"Online"} />
                      <CustomButton Data={PaymentMode} setData={setPaymentMode} DataValue={"Cash"} />
                      <CustomButton Data={PaymentMode} setData={setPaymentMode} DataValue={"Cheque"} />
                    </>
                    {/* :
                    <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}>
                      <div className={"active-option"}>
                        {PaymentMode}
                      </div>
                    </button>
                  } */}
                </td>
              </tr>
              <tr>
                <td className="col-3">Reference Number</td>
                <td className="col-6">
                  <input className="input-common"
                    value={ReferenceNumber} placeholder="Reference Number such as transaction No"
                    onChange={(event) => { setReferenceNumber(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Received By</td>
                <td className="col-6">
                  <input className="input-common"
                    value={ReceivedBy} placeholder="Received By"
                    onChange={(event) => { setReceivedBy(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Received From</td>
                <td className="col-6">
                  <input className="input-common"
                    value={ReceivedFrom} placeholder="Received From"
                    onChange={(event) => { setReceivedFrom(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Remarks 1</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Remarks1} placeholder="Remarks 1"
                    onChange={(event) => { setRemarks1(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Remarks 2</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Remarks2} placeholder="Remarks 2"
                    onChange={(event) => { setRemarks2(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Remarks 3</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Remarks3} placeholder="Remarks 3"
                    onChange={(event) => { setRemarks3(event.target.value) }}
                  />
                </td>
              </tr>
              {/* <tr>
                <td className="col-3">Screenshot</td>
                <td className="col-6">
                  <ImageUpload
                    ImageUrl={Screenshot}
                    setImageUrl={setScreenshot}
                  />
                </td>
              </tr> */}
              <tr>
                <td className="col-3">Screenshot</td>
                <td className="col-6">
                  {ShowScreenShotGroupList &&
                    <div style={{ padding: "0 10px" }}>
                      {Object.values(Screenshot).map((item, index) => (
                        <div key={index} style={{ display: "flex", padding: "3px 0" }}>
                          <span style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</span>
                          <span>
                            <FileUploadImage
                              ImageGroup={Screenshot}
                              setImageGroup={setScreenshot}
                              ThisImage={item}
                              index={index}
                            />
                          </span>
                          <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                            var ObjectForDelete = Screenshot
                            var key = Object.keys(Screenshot)[index]
                            console.log(key, Screenshot)
                            delete ObjectForDelete[key];
                            setScreenshot(ObjectForDelete)
                            setShowScreenShotGroupList(false)
                            setTimeout(() => {
                              setShowScreenShotGroupList(true)
                            }, 10)
                          }}>
                            Delete
                          </span>
                        </div>
                      ))}
                      <div className=" col-3" style={{ padding: "0 10px" }}>
                        <div className="sign-in-button-small"
                          onClick={() => {
                            var newValue = ""
                            var lastkey = Object.keys(Screenshot).length == 0 ? -1 : Number(Object.keys(Screenshot)[Object.keys(Screenshot).length - 1])
                            console.log(lastkey + 1)
                            var newKey = `${lastkey + 1}`
                            var newObject = Screenshot;
                            newObject = {
                              ...Screenshot,
                              [newKey]: newValue
                            }
                            console.log(newObject)

                            setScreenshot(newObject)
                          }}
                        >
                          Add Screenshot
                        </div>
                      </div>
                    </div>
                  }
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Income
              </div>
            </div>
            {ID !== "" &&
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    invoiceComponentPrint()

                  }}
                >
                  Print Receipt
                </div>
              </div>
            }
          </div>
        </div>
      </div >

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
      {
        StudentModal &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setStudentModal(false)
                  }}
                >X</div>
                <StudentExamModal
                  setStudentID={setStudentID}
                  setStudentName={setStudentName}
                  setStudentSlug={setStudentSlug}
                  StudentID={StudentID}
                  setStudentModal={setStudentModal}
                  StudentsList={StudentsList}
                  StudentsList={StudentsList1}
                />
              </div>
            </div>
          </div>
        </section>
      }

      <div
        style={{ display: "none" }}
      >
        <div ref={invoiceComponentRef}>

          <section className="bill">
            <header className="top">
              <div className="regd">Regd.: 327859/060/061</div>

              <div className="logo">
                {/* <div className="nea">NEA</div>
                        <div className="network">NETWORK</div>
                        <div className="academy">EDUCATIONAL ACADEMY</div> */}
                <img src={signInImage} style={{ width: "100px" }} />
              </div>

              <div className="company">
                <h1>Network Educational Academy</h1>
                <h2>Bagbazar-28 Kathmandu</h2>
                <p>Contact : 015921577, 9844085262, 9844832140</p>
                <p>email : info@networkeducationalacademy.com</p>
              </div>

              <div className="right-top">
                <div className="date-line">
                  <label>Date:</label>
                  <div className="underline">{FetchData.date.slice(0, 10)}</div>
                </div>
              </div>
            </header>

            <div className="invoice-word">INVOICE</div>

            <div className="form-row row-vat">
              <span className="label">VAT No.</span>

              <div className="box-set" aria-label="VAT number">
                619853527
              </div>

              <span></span>
              {/* <span className="label">Invoice No.</span>
                        <input className="invoice-number" value="751" /> */}
            </div>

            <div className="form-row row-name">
              <span className="label">M/S:</span>
              <div className="underline">{Title}</div>
              {/* <input className="underlined" value="Santosh Acharya" /> */}
            </div>

            <div className="form-row row-address">
              {/* <span className="label">Address:</span>
                    <div className="underline">{Address}</div> */}
              {/* <input className="underlined" value="" /> */}
              <span className="label">Receipt No.</span>
              <div className="underline">{ReceiptNumber}</div>
              {/* <input className="invoice-number" value="751" /> */}
            </div>

            <div className="form-row row-pan">
              <span className="payment">Mode of Payment: {PaymentMode}</span>
              {/* <input className="underlined" style={{ fontSize: "15px" }} value="" /> */}
            </div>

            <table className="items">
              <thead>
                <tr>
                  <th className="sn">S.N.</th>
                  <th className="hs">H.S.Code</th>
                  <th className="particular">Particulars</th>
                  <th className="qty">Qty.</th>
                  <th className="rate">Rate</th>
                  <th className="amount">Amount</th>
                </tr>
              </thead>
              <tbody>
                {Object.values(Items).map((item, index) => (
                  <tr key={index}>
                    <td><div className="number-field" >{index + 1}</div></td>
                    <td><input value="" /></td>
                    <td><div className="number-field" >{item.name}</div></td>
                    <td><div className="number-field" >{item.qty}</div></td>
                    <td><div className="number-field" >{item.rate}</div></td>
                    <td><div className="number-field" >{item.total}</div></td>
                  </tr>
                ))}
                {/* <tr style={{height:"70px"}}>
                        <td colSpan={4}>aa</td>
                        <td className="sum-label">Total</td>
                        <td><div className="number-field" >{Amount}</div></td>
                      </tr> */}
              </tbody>
            </table>

            <div className="bottom">
              <div className="words">
                <span className="words-title">In Words:</span>
                <span id="amountWords" className="words-value">{converter.toWords(Number(Amount)).toUpperCase()} RUPEES Only</span>
              </div>

              <table className="summary">
                <tr>
                  <td className="sum-label">Total</td>
                  <td><div className="number-field" >{Amount}</div></td>
                </tr>
              </table>
            </div>

            {/* <footer className="footer"> */}
            <div className="footer">
              <div>E. &amp; O. E.</div>
              <div className="signature">
                <div className="signature-space"></div>
                <div className="signature-line">For: Network Educational Academy</div>
              </div>
            </div>
            <div></div>
            {/* </footer> */}
          </section>
        </div>
      </div>

    </div >
  )

}